module.exports = __webpack_public_path__ + "img/52_20.9aee4472.png";